export class ChecklistItem {
  constructor(
    public text: string,
    public checked: boolean = false,
    public disabled: boolean = false,
    public html: boolean = false,
  ) {}
}
